import type { SVGProps } from "react";
import * as React from "react";

const SvgCornerLeftUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.293 9.707a1 1 0 0 0 1.414-1.414zM9 4l.707-.707a1 1 0 0 0-1.414 0zM3.293 8.293a1 1 0 0 0 1.414 1.414zM20 21a1 1 0 1 0 0-2zM9 16H8zm5.707-7.707-5-5-1.414 1.414 5 5zm-6.414-5-5 5 1.414 1.414 5-5zM20 19h-7v2h7zm-7 0a3 3 0 0 1-2.121-.879l-1.415 1.415A5 5 0 0 0 13 21zm-2.121-.879A3 3 0 0 1 10 16H8a5 5 0 0 0 1.464 3.535zM10 16V4H8v12z"
    />
  </svg>
);
export default SvgCornerLeftUp;
